import { withJsonFormsControlProps } from "@jsonforms/react";
import CheckboxField from "./CheckboxField";

const CheckboxComponent = (props) => {
  const {
    handleChange,
    label,
    data,
    path,
    errors,
    schema,
    uischema,
    enabled,
    required,
  } = props;
  return (
    <CheckboxField
      value={data}
      label={label}
      updateValue={(newVal) => handleChange(path, newVal)}
      errors={errors}
      schema={schema}
      uiSchema={uischema}
      required={required}
      disabled={!enabled}
    />
  );
};

export const CheckboxControl = withJsonFormsControlProps(CheckboxComponent);
